import type { CryptoSwapFilterId } from "../constants/cryptoSwaps.constants";
import { CryptoSwapsService } from "../services/cryptoSwaps.service";
import type { OtcOrder } from "../types/cryptoSwaps.types";
import { buildOrdersQuery, DEFAULT_CRYPTO_SWAP_FILTERS } from "../utils/cryptoSwapFilters";
import { isNonTerminalStatus } from "../utils/cryptoSwapStatus";
import { useOtcOrdersPage, type UseOtcOrdersPageResult } from "./useOtcOrdersPage";

export type UseCryptoSwapOrdersResult = UseOtcOrdersPageResult<OtcOrder, CryptoSwapFilterId>;

const isLiveOrder = (order: OtcOrder) => isNonTerminalStatus(order.status);

/** The purchase history. */
export function useCryptoSwapOrders(): UseCryptoSwapOrdersResult {
  return useOtcOrdersPage({
    list: CryptoSwapsService.listOrders,
    buildQuery: buildOrdersQuery,
    isLive: isLiveOrder,
    defaultFilters: DEFAULT_CRYPTO_SWAP_FILTERS,
  });
}
